export const superAdminOnboardingLink = (num) =>
  `/super-admin-onboarding/step-${num}`;
